import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f56f6c4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Enter an email so that we can send you password reset link")
], -1))
const _hoisted_3 = { class: "form_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: ""
}, "Enter Email", -1))
const _hoisted_5 = { class: "forgot-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If the email address has an account, an email will be sent with a link to reset your password. ", -1))
const _hoisted_7 = { class: "email__wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Didn’t receive email? Request a resend below.", -1))
const _hoisted_10 = { class: "btn_text" }
const _hoisted_11 = { class: "benefit_wrapper llg:!tw-mb-[20px]" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Take a look at all the amazing benefits iknowa offers", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AuthIknowaInfoMobileModal = _resolveComponent("AuthIknowaInfoMobileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$setup.isShowSendEmail)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _createVNode(_component_v_form, {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.onEmailSend()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_v_text_field, {
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    class: "input_field",
                    modelValue: $setup.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
                    rules: $setup.rules,
                    "validate-on": "submit",
                    placeholder: "email address",
                    rounded: "",
                    outlined: "false",
                    variant: "solo"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createVNode(_component_v_btn, {
                  class: "button button-orange send-mail",
                  type: "submit",
                  block: "",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send Email")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Email Sent To : "),
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString($setup.email), 1)
                ])
              ]),
              _hoisted_9
            ]),
            _createVNode(_component_v_btn, {
              class: "button button-orange resend-mail",
              type: "submit",
              size: "large",
              block: "",
              onClick: $setup.onEmailSend
            }, {
              default: _withCtx(() => [
                _createTextVNode("Re-Send Email")
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", {
          class: "yellow-text",
          type: "submit",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickLoginButton()))
        }, [
          _createTextVNode(" Back To Log In"),
          _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h6", null, [
            _createVNode(_component_v_icon, { icon: "mdi-star" }),
            _createTextVNode("iknowa Benefits")
          ])
        ]),
        _hoisted_13,
        _createElementVNode("label", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openOverview && $setup.openOverview(...args))),
          class: "yellow-text"
        }, [
          _createTextVNode("Open iknowa Overview "),
          _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
        ])
      ])
    ]),
    ($setup.isShowAuthIknowaInfoMobile)
      ? (_openBlock(), _createBlock(_component_AuthIknowaInfoMobileModal, {
          key: 0,
          onOnCloseButtonClick: $setup.onCloseButtonClick
        }, null, 8, ["onOnCloseButtonClick"]))
      : _createCommentVNode("", true)
  ], 64))
}